import { freeze } from '@reduxjs/toolkit';
import { EntityTabType } from '../../../components/QuickAccessDictionary/DictionaryTabs/types';
import { DashboardSidebarSetting } from '../../../pages/DashboardRoute/DashboardNav/components/validation';
import { DefaultView, SidebarViewState } from '../../../utils/userSettings';
import { MIN_SCRATCHPAD_WIDTH } from '../../../config/constants';

export interface IWindowSize {
  width: number;
  height: number;
}

export interface IQuickAccessDictionaryTabSettings {
  activeIndices: number[];
}

export interface IQuickAccessDictionarySetting {
  viewState: SidebarViewState;
  currentTab: EntityTabType;
  [EntityTabType.Events]: IQuickAccessDictionaryTabSettings;
  [EntityTabType.Fields]: IQuickAccessDictionaryTabSettings;
  [EntityTabType.Measures]: IQuickAccessDictionaryTabSettings;
  [EntityTabType.Cohorts]: IQuickAccessDictionaryTabSettings;
}

export enum SidebarState {
  Collapsed = 'COLLAPSED',
  Dictionary = 'DICTIONARY',
  Scratchpad = 'SCRATCHPAD',
  ExplainWithAi = 'EXPLAIN_WITH_AI',
  Comments = 'COMMENTS',
}

export interface ISidebarState {
  sidebarState: SidebarState;
  quickAccessDictionary: IQuickAccessDictionarySetting;
}

export interface IUserSettings {
  windowSize: IWindowSize;
  jupyterHost: string;
  sidebarState: ISidebarState;
  dashboardSidebarSetting: DashboardSidebarSetting | null;
  isExecutionHistorySidebarExpanded: boolean;
  defaultView: DefaultView;
  defaultSchemaId: string;
  activeSchemaId: string | null;
  sidebarSize: number;
  colorSchemaSetting: string;
}

export const defaultQuickAccessDictionaryState =
  freeze<IQuickAccessDictionarySetting>(
    {
      viewState: SidebarViewState.Expanded,
      currentTab: EntityTabType.Events,
      [EntityTabType.Events]: {
        activeIndices: [],
      },
      [EntityTabType.Fields]: {
        activeIndices: [],
      },
      [EntityTabType.Measures]: {
        activeIndices: [0],
      },
      [EntityTabType.Cohorts]: {
        activeIndices: [0],
      },
    },
    true,
  );

const defaultWindowSize: IWindowSize = {
  width: 0,
  height: 0,
};

const defaultSidebarState = freeze<ISidebarState>(
  {
    sidebarState: SidebarState.Collapsed,
    quickAccessDictionary: defaultQuickAccessDictionaryState,
  },
  true,
);

export const initialUserSettingsSliceState = freeze<IUserSettings>(
  {
    windowSize: defaultWindowSize,
    jupyterHost: '',
    sidebarState: defaultSidebarState,
    dashboardSidebarSetting: null,
    isExecutionHistorySidebarExpanded: true,
    defaultView: DefaultView.StandardView,
    defaultSchemaId: '',
    activeSchemaId: null,
    sidebarSize: MIN_SCRATCHPAD_WIDTH,
    colorSchemaSetting: '',
  },
  true,
);
